import { IProps } from './types';
import { MainContainer } from './styles';

function Backdrop({ toggleShowSidebar }: IProps) {
  return <MainContainer onClick={toggleShowSidebar} />;
}

export default Backdrop;
